import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Clock, Instagram, Facebook, Send } from 'lucide-react';
export function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="bg-white min-h-screen" data-id="element-363">
      {/* Hero Section */}
      <section className="relative h-[50vh] md:h-[60vh] w-full overflow-hidden" data-id="element-364">
        <img src="https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&q=80&w=2000" alt="Contact Versatile LLC" className="w-full h-full object-cover" data-id="element-365" />
        <div className="absolute inset-0 bg-brand-black/60" data-id="element-366" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-4 md:px-6" data-id="element-367">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-368">
            <span className="text-brand-gold font-bold tracking-[0.3em] uppercase text-[10px] md:text-xs mb-4 block" data-id="element-369">
              Get In Touch
            </span>
            <h1 className="text-white text-4xl sm:text-5xl md:text-7xl font-serif" data-id="element-370">
              Let's Plan Your Event
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 md:py-24 max-w-7xl mx-auto px-4 md:px-6" data-id="element-371">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-372">
          {/* Left Column: Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-373">
            <h2 className="text-3xl md:text-4xl font-serif mb-6 text-brand-black" data-id="element-374">
              We'd Love to Hear From You
            </h2>
            <p className="text-gray-600 leading-relaxed mb-12" data-id="element-375">
              Whether you're planning a grand wedding, a corporate luncheon, or
              looking for weekly meal prep, our team is ready to bring your
              culinary vision to life. Reach out to us using the form, or
              contact us directly.
            </p>

            <div className="space-y-8" data-id="element-376">
              <div className="flex items-start gap-4" data-id="element-377">
                <div className="w-12 h-12 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center shrink-0" data-id="element-378">
                  <Phone size={20} data-id="element-379" />
                </div>
                <div data-id="element-380">
                  <h3 className="font-bold text-brand-black text-lg" data-id="element-381">
                    Call Us
                  </h3>
                  <p className="text-gray-500 mt-1" data-id="element-382">(202) 555-0123</p>
                  <p className="text-xs text-gray-400 mt-1 uppercase tracking-widest" data-id="element-383">
                    Mon-Fri, 9am - 6pm
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-384">
                <div className="w-12 h-12 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center shrink-0" data-id="element-385">
                  <Mail size={20} data-id="element-386" />
                </div>
                <div data-id="element-387">
                  <h3 className="font-bold text-brand-black text-lg" data-id="element-388">
                    Email Us
                  </h3>
                  <p className="text-gray-500 mt-1" data-id="element-389">
                    hello@versatilityeats.com
                  </p>
                  <p className="text-xs text-gray-400 mt-1 uppercase tracking-widest" data-id="element-390">
                    We reply within 24 hours
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-391">
                <div className="w-12 h-12 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center shrink-0" data-id="element-392">
                  <MapPin size={20} data-id="element-393" />
                </div>
                <div data-id="element-394">
                  <h3 className="font-bold text-brand-black text-lg" data-id="element-395">
                    Location
                  </h3>
                  <p className="text-gray-500 mt-1" data-id="element-396">Gaithersburg, MD</p>
                  <p className="text-xs text-gray-400 mt-1 uppercase tracking-widest" data-id="element-397">
                    Serving the entire DMV Area
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-12 border-t border-gray-100" data-id="element-398">
              <h3 className="font-bold text-brand-black mb-4 uppercase tracking-widest text-sm" data-id="element-399">
                Follow Our Journey
              </h3>
              <div className="flex gap-4" data-id="element-400">
                <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-brand-gold hover:text-white transition-all" data-id="element-401">
                  <Instagram size={18} data-id="element-402" />
                </a>
                <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-brand-gold hover:text-white transition-all" data-id="element-403">
                  <Facebook size={18} data-id="element-404" />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} className="bg-gray-50 p-8 md:p-10 rounded-sm border border-gray-100" data-id="element-405">
            <h3 className="text-2xl font-serif mb-8 text-brand-black" data-id="element-406">
              Send a Message
            </h3>
            <form className="space-y-6" onSubmit={e => {
            e.preventDefault();
            alert('Message sent successfully!');
          }} data-id="element-407">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-408">
                <div data-id="element-409">
                  <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-410">
                    First Name
                  </label>
                  <input type="text" required className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white" data-id="element-411" />
                </div>
                <div data-id="element-412">
                  <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-413">
                    Last Name
                  </label>
                  <input type="text" required className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white" data-id="element-414" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-415">
                <div data-id="element-416">
                  <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-417">
                    Email Address
                  </label>
                  <input type="email" required className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white" data-id="element-418" />
                </div>
                <div data-id="element-419">
                  <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-420">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white" data-id="element-421" />
                </div>
              </div>

              <div data-id="element-422">
                <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-423">
                  Inquiry Type
                </label>
                <select className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white text-gray-700" data-id="element-424">
                  <option data-id="element-425">General Inquiry</option>
                  <option data-id="element-426">Wedding Catering</option>
                  <option data-id="element-427">Corporate Event</option>
                  <option data-id="element-428">Meal Prep Subscription</option>
                  <option data-id="element-429">Private Party</option>
                </select>
              </div>

              <div data-id="element-430">
                <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-431">
                  Message
                </label>
                <textarea required rows={5} className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white resize-none" placeholder="Tell us about your event or ask a question..." data-id="element-432"></textarea>
              </div>

              <button type="submit" className="w-full bg-brand-black text-white py-4 rounded-sm font-bold uppercase tracking-widest hover:bg-brand-gold transition-all flex items-center justify-center gap-2" data-id="element-433">
                Send Message <Send size={16} data-id="element-434" />
              </button>
            </form>
          </motion.div>
        </div>
      </section>
    </div>;
}